import React, { useEffect, useRef, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { clearDeviceLogs, UpdateDeviceDetails, UpdateDeviceDetailsExtras } from '../../../../Api Methods/Api';
import ComponentCard from '../../Cards/ComponentCard/ComponentCard'
import EditPinForm from '../../Cards/FormCard/EditPinForm'
import classes from './EditPin.module.css'
import { serviceActions } from '../../../../store/service-Slice';

function overwriteKeyInObject(obj, key, newValue) {
    return {
        ...obj,
        [key]: newValue
    };
}

const EditPin = ({ PinDetails, HandleToggleEditPinView, setPinEdited, setSiteData, setShowEditPinForm }) => {



    const [newDeviceDetails, setNewDeviceDetails] = useState(null);
    const [newDeviceDetailsExtras, setNewDeviceDetailsExtras] = useState(null)

    const [isUpdating, setIsUpdating] = useState(false);
    const [reloadPending, setReloadPending] = useState(false);
    const reloadOnSaveRef = useRef(false);
    const setReloadOnSave = (val) => { reloadOnSaveRef.current = val; };

    let DeviceID = useSelector(state => state.service.DeviceID);


    const siteData = useSelector(state => state.service.SiteData)
    const DeviceDetails = JSON.parse(siteData.deviceDetails)
    const DeviceDetailsExtras = JSON.parse(siteData.deviceExtraDetails)

    const client = useSelector(state => state.auth.client);
    const token = useSelector(state => state.auth.token);

    const apiData = {
        token,
        client,
    }

    const dispatch = useDispatch();

    useEffect(() => {
        if (newDeviceDetails !== null && newDeviceDetailsExtras !== null && !isUpdating) {
            setIsUpdating(true)
            let keyToOverwrite = PinDetails.InputPin ? PinDetails.InputPin.Pin : PinDetails.Pin
            const updatedDeviceDetails = overwriteKeyInObject(DeviceDetails, keyToOverwrite, newDeviceDetails[keyToOverwrite]);
            const updatedDeviceDetailsExtras = overwriteKeyInObject(DeviceDetailsExtras, keyToOverwrite, newDeviceDetailsExtras[keyToOverwrite]);
            let newData = {
                ...siteData,
                deviceDetails: JSON.stringify(updatedDeviceDetails),
                deviceExtraDetails: JSON.stringify(updatedDeviceDetailsExtras)
            }

            const UpdateDevice = async () => {
                let newDetails = {
                    deviceDetails: updatedDeviceDetails
                };
                let newDetailsExtras = {
                    deviceExtraDetails: updatedDeviceDetailsExtras
                }

                const responseUpdateDetails = await UpdateDeviceDetails(apiData, newDetails, DeviceID, dispatch);
                const responseUpdateDetailsExtra = await UpdateDeviceDetailsExtras(apiData, newDetailsExtras, DeviceID, dispatch);
                if (responseUpdateDetails && responseUpdateDetailsExtra) {
                    setShowEditPinForm(false)
                    setPinEdited(true);
                    setSiteData(HandleResponseData(newData, dispatch))
                    setIsUpdating(false);
                    if (reloadOnSaveRef.current) {
                        setReloadPending(true);
                        setTimeout(() => window.location.reload(), 1500);
                    }
                }
            }
            

            UpdateDevice();
            setNewDeviceDetails(null);
            setNewDeviceDetailsExtras(null);
        }

        
    }, [newDeviceDetails, newDeviceDetailsExtras])

    // useEffect(() => {
    //     if (newDeviceDetailsExtras != null) {
    //         let keyToOverwrite = PinDetails.InputPin ? PinDetails.InputPin.Pin : PinDetails.Pin
    //         const updatedDeviceDetails = overwriteKeyInObject(deviceExtras, keyToOverwrite, newDeviceDetailsExtras[keyToOverwrite]);
            
    //         let newData = {
    //             ...siteData.data[0],
    //             deviceExtraDetails: updatedDeviceDetails
    //         }

    //         const UpdateDeviceExtras = async () => {
    //             let newDetails = {
    //                 deviceExtraDetails: updatedDeviceDetails
    //             };

    //             const response = await UpdateDeviceDetailsExtras(apiData, newDetails, DeviceID, dispatch);
    //             if (response) {
    //                 HandleToggleEditPinView()
    //                 setPinEdited(true)
    //                 setSiteData(HandleResponseData(newData, dispatch))
    //                 setDeviceExtras(updatedDeviceDetails)
    //             }
    //         }

    //         UpdateDeviceExtras();
    //         setNewDeviceDetailsExtras(null);
    //     }

    // }, [newDeviceDetailsExtras])

    if (reloadPending) {
        return (
            <ComponentCard id="OutPutPinListCard" className={classes["pin-switches"]}>
                <p style={{ textAlign: "center", color: "#858585", fontSize: "15px", padding: "20px" }}>Switch type updated. Reloading page to apply changes…</p>
            </ComponentCard>
        )
    }

    return (
        <ComponentCard id="OutPutPinListCard" className={classes["pin-switches"]}>
            <EditPinForm PinDetails={PinDetails} setNewDeviceDetails={setNewDeviceDetails} setNewDeviceDetailsExtras={setNewDeviceDetailsExtras} setPinEdited={setPinEdited} setReloadOnSave={setReloadOnSave} deviceDetails={DeviceDetails}/>
        </ComponentCard>
    )
}

const HandleResponseData = (result, dispatch) => {
    let OutPutPins = [5, 6, 13, 19];
    if (result.type == "S"){
        OutPutPins = [5, 6, 13, 19, 25, 26, 27, 28];
    }
    const {
        id,
        name,
        mac,
        key,
        ip,
        host,
        uuid,
        online,
        created,
        lastLoggedIn,
        status,
        tag,
        networkType,
        deviceDetails,
        firmware,
        type,
        numInput,
        numOutput,
        subGroup,
        deviceExtraDetails,
        latestFirmware,
        deviceName,
        monitoredBy,
        active,
        liveViewEnabled,
        scheduleOnly,
        iglooLocks,
        integrationRelationships,
    } = result;

    const rawDeviceDetails = typeof deviceDetails === "string" ? JSON.parse(deviceDetails) : deviceDetails;
    const DeviceDetailsParsed = rawDeviceDetails.deviceDetails ? rawDeviceDetails.deviceDetails : rawDeviceDetails;

    const rawDeviceExtraDetails = typeof deviceExtraDetails === "string" ? JSON.parse(deviceExtraDetails) : deviceExtraDetails;
    const DeviceExtraDetailsParsed = rawDeviceExtraDetails.deviceExtraDetails ? rawDeviceExtraDetails.deviceExtraDetails : rawDeviceExtraDetails;

    const allPinsNotificationActive = DeviceDetailsParsed.allPinsNotificationActive;
    const allPinsNotificationSound = DeviceDetailsParsed.allPinsNotificationSound;
    const camectIntegrationType = DeviceDetailsParsed.camectIntegrationType;
    const singleDeviceName = DeviceDetailsParsed.name;
    const offlineNotificationActive = DeviceDetailsParsed.offlineNotificationActive;
    const offlineNotificationSound = DeviceDetailsParsed.offlineNotificationSound;
    const onlineNotificationActive = DeviceDetailsParsed.onlineNotificationActive;
    const onlineNotificationSound = DeviceDetailsParsed.onlineNotificationSound;
    const polarity = DeviceDetailsParsed.polarity;
    const polarityReason = DeviceDetailsParsed.polarityReason;
    const singleDeviceSettingData = { online, numOutput, numInput, allPinsNotificationActive, allPinsNotificationSound, camectIntegrationType, singleDeviceName, offlineNotificationActive, onlineNotificationActive, offlineNotificationSound, onlineNotificationSound, polarity, polarityReason, lastLoggedIn, iglooLocks, monitoredBy, active, liveViewEnabled, scheduleOnly }
    const DeviceOutputPins = OutPutPins.map((output) => { const value = DeviceDetailsParsed[output]; return { ...value, Pin: output }; }).filter((obj) => obj !== undefined);

    dispatch(serviceActions.setDeviceDetails([DeviceDetailsParsed, id, DeviceExtraDetailsParsed]));
    dispatch(serviceActions.setSiteData(result))

    let InputPins;
    if (numInput != 0) {
        let DeviceInputPins;
        if (numInput == 4) {
            const InputsPins = [21, 20, 16, 12];
            DeviceInputPins = InputsPins.map((input) => { const value = DeviceDetailsParsed[input]; return { ...value, Pin: input }; }).filter((obj) => obj !== undefined);
        } else if (numInput == 8) {
            const InputsPins = [21, 20, 16, 12, 4, 3, 2, 1];
            DeviceInputPins = InputsPins.map((input) => { const value = DeviceDetailsParsed[input]; return { ...value, Pin: input }; }).filter((obj) => obj !== undefined);
        }

        let InputDeviceIcons;
        if (numInput == 4) {
            const InputsPins = [21, 20, 16, 12];
            //Input Device Icons
            InputDeviceIcons = InputsPins.map((input) => DeviceExtraDetailsParsed[input]).filter((value) => value !== undefined);
        } else if (numInput == 8) {
            const InputsPins = [21, 20, 16, 12, 4, 3, 2, 1];
            InputDeviceIcons = InputsPins.map((input) => DeviceExtraDetailsParsed[input]).filter((value) => value !== undefined);
        }
        const arrayOfInputDeviceIcons = Object.values(InputDeviceIcons);
        const arrayOfInputDeviceIconsValues = arrayOfInputDeviceIcons.map(obj => obj.icon);
        const arrayOfInputManagerOnlyValues = arrayOfInputDeviceIcons.map(obj => obj.accessLevel);
        const arrayOfInputReadOnlyValues = arrayOfInputDeviceIcons.map(obj => obj.readOnly);
        const arrayOfInputTempLatchAllowedValues = arrayOfInputDeviceIcons.map(obj => obj.tempLatchAllowed);
        const arrayOfInputTempLatchStandardRestrictionValues = arrayOfInputDeviceIcons.map(obj => obj.tempLatchStandardRestriction);

        InputPins = DeviceInputPins.map((item, index) => {
            let icon = arrayOfInputDeviceIconsValues[index];
            let accessLevel = arrayOfInputManagerOnlyValues[index];
            let readOnly = arrayOfInputReadOnlyValues[index];
            let tempLatchAllowed = arrayOfInputTempLatchAllowedValues[index];
            let tempLatchStandardRestriction = arrayOfInputTempLatchStandardRestrictionValues[index];

            if (icon != undefined) {
                {
                    if (icon.includes('.png')) {
                        // //slice off .png
                        icon = icon.slice(0, -4) /*+ '.svg';*/
                    } else {
                        icon = icon /*+ '.svg';*/
                    }
                }
            } else {
                icon = 'default.svg'
            }
            return { ...item, icon, accessLevel, readOnly, tempLatchAllowed, tempLatchStandardRestriction };
        });
    }

    const OutputDeviceIcons = OutPutPins.map((output) => DeviceExtraDetailsParsed[output]).filter((value) => value !== undefined);
    const arrayOfOutputDeviceIcons = Object.values(OutputDeviceIcons);
    const arrayOfOutputDeviceIconsValues = arrayOfOutputDeviceIcons.map(obj => obj.icon);
    const arrayOfOutputManagerOnlyValues = arrayOfOutputDeviceIcons.map(obj => obj.accessLevel);
    const arrayOfOutputReadOnlyValues = arrayOfOutputDeviceIcons.map(obj => obj.readOnly);
    const arrayOfOutputTempLatchAllowedValues = arrayOfOutputDeviceIcons.map(obj => obj.tempLatchAllowed);
    const arrayOfOutputTempLatchStandardRestrictionValues = arrayOfOutputDeviceIcons.map(obj => obj.tempLatchStandardRestriction);

    const relationshipMap = Object.fromEntries(
        (integrationRelationships || []).map(r => [Number(r.pin), r.missed_polls])
    );
    const missedPollsObj = OutPutPins.map(pin => ({
        pin,
        missed_polls: relationshipMap[pin] ?? 0
    }));

    const OutputPins = DeviceOutputPins.map((item, index) => {
        let icon = arrayOfOutputDeviceIconsValues[index];
        let accessLevel = arrayOfOutputManagerOnlyValues[index];
        let readOnly = arrayOfOutputReadOnlyValues[index];
        let tempLatchAllowed = arrayOfOutputTempLatchAllowedValues[index];
        let tempLatchStandardRestriction = arrayOfOutputTempLatchStandardRestrictionValues[index];
        let missedPolls = missedPollsObj[index]?.missed_polls ?? 0;
        let DeviceUUID = uuid;
        let DeviceType = type;

        if (icon.includes('.png')) {
            icon = icon.slice(0, -4)
        } else {
            icon = icon
        }
        return { ...item, icon, accessLevel, readOnly, tempLatchAllowed, tempLatchStandardRestriction, DeviceUUID, DeviceType, missedPolls };
    });

    const ResponseData = [
        { OutputPins, InputPins, singleDeviceSettingData },
        { id, name, mac, key, ip, host, uuid, online, created, lastLoggedIn, status, tag, networkType, firmware, type, subGroup, numInput, numOutput, latestFirmware, camectIntegrationType, deviceName, monitoredBy, active, liveViewEnabled, scheduleOnly }
    ]

    return ResponseData;
}

export default EditPin